module.exports = __webpack_public_path__ + "img/air_conditioning.80c395ca.svg";